/**
 * User domain service
 * Contains business logic related to user operations
 */

export interface UserData {
  sender_docs_user?: any;
  [key: string]: any;
}

/**
 * Checks if the user can contract a service
 * User can contract if they exist, have the sender_docs_user property, it's null, and they are not a customer
 *
 * @param userData - User data object
 * @returns true if user can contract the service, false otherwise
 */
export function canUserContractService(userData: UserData | null | undefined): boolean {
  if (!userData) {
    return false;
  }

  if (!userData.hasOwnProperty('sender_docs_user')) {
    return false;
  }

  // Exclude customers from contracting services
  if (userData.user_role && userData.user_role.value === 'customer') {
    return false;
  }

  return userData.sender_docs_user === null;
}
